export const cssVariables = {
  breakpoints: {
    '3xl': 1920,
    '2xl': 1536,
    xl: 1280,
    lg: 1024,
    md: 768,
    sm: 640,
  },
  colors: {
    transparent: 'transparent',
    current: 'currentColor',
    white: '#FFFFFF',
    red: '#FF0000',
    black: '#000000',
    green: {
      DEFAULT: '#23DCB5',
      light: '#D9FFF7',
      1: '#00C5B0',
      2: '#66DACF',
      3: '#D6F4EF',
      4: '#EBF9F7',
      5: '#F4FFFD',
    },
    pink: {
      DEFAULT: '#FF32B9',
      light: '#FFE9F7',
      1: '#FF32B9',
      2: '#FF85D3',
      3: '#FFD1EE',
      4: '#FFE8F7',
      5: '#FFF9FD',
    },
    navy: {
      DEFAULT: '#2A2A68',
      1: '#2A2A68',
      2: '#7C7CA0',
      3: '#D8D8E4',
      4: '#EBEBF1',
      5: '#F8F8FE',
    },
    blue: {
      DEFAULT: '#1D9BFF',
      light: '#EAF6FF',
      lighter: '#EAF6FF',
      1: '#00B8FC',
      2: '#66D4FD',
      3: '#D6F3FE',
      4: '#EBF9FF',
      5: '#F4FCFF',
    },
    yellow: {
      DEFAULT: '#FFBD00',
      light: '#FFFAEE',
      1: '#FFC926',
      2: '#FFDD6F',
      3: '#FFF2CC',
      4: '#FFF9E5',
      5: '#FFFCF3',
    },
    gray: '#888888',
    border: '#E5E7EB',
    background: '#FFFFFF',
    foreground: '#000000',
  },
  typography: {
    sizes: {
      xs: '0.875rem', // 14px
      sm: '1rem', // 16px
      base: '1.125rem', // 18px
      lg: '1.25rem', // 20px
      xl: '1.5rem', // 24px
      '2xl': '1.875rem', // 30px
      '3xl': '2.25rem', // 36px
      '4xl': '3rem', // 48px
      '5xl': '3.75rem', // 60px
      '6xl': '4.5rem', // 72px
    },
    lineHeights: {
      tight: '1.1',
      snug: '1.25',
      normal: '1.5',
      relaxed: '1.75',
    },
  },
}
